import React from 'react';
//import {authRoles} from '../../auth';

export const NotificacionesConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['funcionario', 'rh', 'director'],
    routes  : [
        {
            path     : '/notificaciones',
            component: React.lazy(() => import('./Notificaciones'))
        }
    ]
};